import {Link as MuiLink, Button, Stack, styled, useTheme, } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import { RoutePaths } from "../../../routes";


const UnderlineLink = styled(Link)(({ theme }) => ({
    position: 'relative',
    textDecoration: 'none',
    color: theme.palette.primary.main,

    '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: -2, // Отступ подчеркивания от текста
        height: '2px', // Толщина подчеркивания
        transform: 'scaleX(0)',
        transition: 'transform 0.3s ease-in-out',
    },

    '&:hover::after': {
        transform: 'scaleX(1)', // Увеличиваем подчеркивание при наведении
    },
}));


const MenuDesktop = ({ links }) => {
    const theme = useTheme()
    const location = useLocation()
    
    return (
        <>
            <Stack spacing={4} direction='row' alignItems='center' justifyContent='space-between' sx={{
                width: '100%',
            }}>
                <Stack
                    direction='row'
                    alignItems='center'
                    justifyContent='center'
                    sx={{
                        flexGrow: 1,
                        flexWrap: 'wrap',
                    }}
                >
                    {links.map((link, index) => (
                        <UnderlineLink
                            sx={{
                                ...theme.typography.menu,
                                pl: '27px',
                                pr: '27px',
                                color: location.pathname.indexOf(link.url) >=0 ? 'red.500' : 'blue.400',
                                '&::after': {
                                    backgroundColor: location.pathname.indexOf(link.url) >=0  ? 'red.500' : 'blue.400',
                                }
                            }}
                            key={index}
                            to={link.url}
                            onClick={link.handleClick ? link.handleClick : () => null}
                        >
                            {link.label}
                        </UnderlineLink>
                    ))}
                </Stack>

                <Button component={MuiLink} href={RoutePaths.LK} target="_blank" variant="contained">Личный кабинет</Button>
            </Stack >
        </>
    )
}

export default MenuDesktop
